import { utils } from '@febos-io/common';

export const getCompanyUserList = (companyId, page, limit = 1, filter = undefined) => ({
  path: `v1/companies/${companyId}/users`,
  params: {
    page,
    limit,
    ...{ ...(filter && { filter, }), },
  },
});

export const getCompanyUser = (companyId, id) => ({
  path: `v1/companies/${companyId}/users/${id}`,
});

export const getSearchCompanyUserList = (companyId, page, limit = 1, filter = undefined) => ({
  path: `v1/companies/${companyId}/users/search`,
  params: {
    page,
    limit,
    ...{ ...(filter && { filter, }), },
  },
});

export const linkCompanyUser = ({ companyId, userId, }) => ({
  path: `v1/companies/${companyId}/users/${userId}/link`,
  method: utils.METHOD.POST,
  content: {},
});

export const getCompanyUserClinics = (companyId, userId) => ({
  path: `v1/companies/${companyId}/users/${userId}/clinics/`,
});

export const changeUserEmail = (companyId, userId, email) => ({
  path: `v1/companies/${companyId}/users/${userId}/email/`,
  method: utils.METHOD.PUT,
  content: {
    email,
  },
});
export const deleteUserEmail = (companyId, userId, email) => ({
  path: `v1/companies/${companyId}/users/${userId}`,
  method: utils.METHOD.DELETE,
  content: {
    email,
  },
});

export const createCompanyUser = (
  companyId,
  {
    username,
    identificationNumber,
    name,
    middleName,
    lastName,
    motherLastName,
    gender,
    avatar,
    birthDate,
    temporaryPassword,
    roles,
    clinics,
    exams,
  }
) => ({
  path: `v1/companies/${companyId}/users`,
  method: utils.METHOD.POST,
  content: {
    username,
    identificationNumber,
    name,
    middleName,
    lastName,
    motherLastName,
    gender,
    avatar,
    birthDate,
    temporaryPassword,
    roles,
    clinics,
    exams,
  },
});

export const loadCompanyUser = (companyId, body) => ({
  path: `v1/companies/${companyId}/users/_batch`,
  method: utils.METHOD.POST,
  content: body,
});

export const updateCompanyUser = (
  companyId,
  userId,
  {
    email,
    identificationNumber,
    name,
    middleName,
    lastName,
    motherLastName,
    gender,
    avatar,
    birthDate,
    temporaryPassword,
    roles,
    clinics,
    exams,
  }
) => ({
  path: `v1/companies/${companyId}/users/${userId}`,
  method: utils.METHOD.PUT,
  content: {
    email,
    identificationNumber,
    name,
    middleName,
    lastName,
    motherLastName,
    gender,
    avatar,
    birthDate,
    temporaryPassword,
    roles,
    clinics,
    exams,
  },
});

export const editCompanyUser = (companyId, id, props) => ({
  path: `v1/companies/${companyId}/users/${id}`,
  method: utils.METHOD.PATCH,
  content: props,
});
export const getShcedulesConfig = ({ userId, }) => ({
  path: '/v1/schedules',
  method: utils.METHOD.GET,
  params: {
    referenceId: userId,
  },
});

export const postShcedulesConfig = ({ userId, }) => ({
  path: '/v1/schedules/blocks',
  method: utils.METHOD.POST,
  params: {
    referenceId: userId,
  },
});

export const searchShcedulesConfig = ({ filters, pagina = 0, itemsPorPagina = 0, }) => ({
  path: '/v1/schedules/search',
  method: utils.METHOD.GET,
  params: {
    filters,
    pagina,
    itemsPorPagina,
  },
});

export const putShcedulesConfig = ({ referenceId, locationId, days, }) => ({
  path: '/v1/schedules',
  method: utils.METHOD.POST,
  content: {
    referenceId,
    locationId,
    days,
  },
});
